/* tslint:disable */
/* eslint-disable */
/**
 * GlassHouse.Dashboard.Api | v1
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { ApiUserTasksGetPageParameter } from './ApiUserTasksGetPageParameter';
import {
    ApiUserTasksGetPageParameterFromJSON,
    ApiUserTasksGetPageParameterFromJSONTyped,
    ApiUserTasksGetPageParameterToJSON,
    ApiUserTasksGetPageParameterToJSONTyped,
} from './ApiUserTasksGetPageParameter';

/**
 * 
 * @export
 * @interface StatementEmailResponse
 */
export interface StatementEmailResponse {
    /**
     * 
     * @type {ApiUserTasksGetPageParameter}
     * @memberof StatementEmailResponse
     */
    userId: ApiUserTasksGetPageParameter;
    /**
     * 
     * @type {string}
     * @memberof StatementEmailResponse
     */
    currency: string;
    /**
     * 
     * @type {string}
     * @memberof StatementEmailResponse
     */
    email: string;
    /**
     * 
     * @type {number}
     * @memberof StatementEmailResponse
     */
    totalAmount: number;
    /**
     * 
     * @type {boolean}
     * @memberof StatementEmailResponse
     */
    isQueued: boolean;
}

/**
 * Check if a given object implements the StatementEmailResponse interface.
 */
export function instanceOfStatementEmailResponse(value: object): value is StatementEmailResponse {
    if (!('userId' in value) || value['userId'] === undefined) return false;
    if (!('currency' in value) || value['currency'] === undefined) return false;
    if (!('email' in value) || value['email'] === undefined) return false;
    if (!('totalAmount' in value) || value['totalAmount'] === undefined) return false;
    if (!('isQueued' in value) || value['isQueued'] === undefined) return false;
    return true;
}

export function StatementEmailResponseFromJSON(json: any): StatementEmailResponse {
    return StatementEmailResponseFromJSONTyped(json, false);
}

export function StatementEmailResponseFromJSONTyped(json: any, ignoreDiscriminator: boolean): StatementEmailResponse {
    if (json == null) {
        return json;
    }
    return {
        
        'userId': ApiUserTasksGetPageParameterFromJSON(json['userId']),
        'currency': json['currency'],
        'email': json['email'],
        'totalAmount': json['totalAmount'],
        'isQueued': json['isQueued'],
    };
}

export function StatementEmailResponseToJSON(json: any): StatementEmailResponse {
    return StatementEmailResponseToJSONTyped(json, false);
}

export function StatementEmailResponseToJSONTyped(value?: StatementEmailResponse | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'userId': ApiUserTasksGetPageParameterToJSON(value['userId']),
        'currency': value['currency'],
        'email': value['email'],
        'totalAmount': value['totalAmount'],
        'isQueued': value['isQueued'],
    };
}

